import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: Arkansas Passport Center or Dallas — no Wichita walk-in",
      "NPIC appointment required before traveling",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to Dallas needed",
      "Ideal for McConnell AFB military families",
      "Perfect for aerospace business travelers",
      "Great for WSU students studying abroad",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Wichita post offices",
      "Good for planned international trips from ICT",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Sedgwick County facilities",
      "Workload shifts with government shutdowns",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
];

export default function WichitaProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Wichita"
      introText="Wichita travelers — McConnell AFB families, aerospace executives at Spirit AeroSystems and Textron, Wichita State University students, and Koch Industries professionals — have several options for getting a passport fast. Here is how they compare, and why most South Central Kansas residents choose a registered passport courier for predictable, professional processing without the drive to Dallas."
      options={options}
      emergencyDescription="Wichita does not have its own regional passport agency. The closest options are Dallas (~360 mi, 5+ hrs) or the Arkansas Passport Center (~400 mi). McConnell AFB families with deployment orders face 10+ hours round-trip. I-35 construction through Oklahoma and Kansas adds unpredictable delays during summer travel season."
      disclaimerText="*Processing speed depends on eligibility and documentation. Wichita does not have a regional passport agency — the closest are Dallas and Arkansas. Not all applicants qualify for Regional Agency Processing."
    />
  );
}